<template>
  <div class="mb-3 mt-1">
    <v-btn class="w-100 mb-3" variant="outlined" @click="createClientAccess">
      <v-icon class="mr-3">mdi-plus</v-icon>
      Надати доступ клієнту
    </v-btn>
    <div v-if="clientAccess?.length">
      <div v-for="access in clientAccess" :key="access.id">
        <v-btn
          class="mr-3"
          variant="plain"
          density="compact"
          icon="mdi-eye"
          @click="showClientAccessInfo(access)"></v-btn>
        <span>Дійсний до: {{ new CustomDate(access.endDate).toString() }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { openDialog } from '@/dialog'
import { shallowRef } from 'vue'
import { handleAsync } from 'best-modules/plugins'
import axios from '@/plugins/axios'
import { urlClientAccessByDocument } from '@/utils/urls'
import { useDocumentSignature } from '../index'
import { CustomDate } from 'best-modules/utils'
import { ENTITY_TYPE } from '@/utils/constants'

export default {
  name: 'ClientAccess',
  methods: { CustomDate },
  setup() {
    const { documentSignatureId, documentSignature } = useDocumentSignature()
    const clientAccess = shallowRef<any[]>([])
    const getClientAccess = () => {
      return handleAsync('getClientAccess', () => {
        return axios
          .get(urlClientAccessByDocument(documentSignatureId.value))
          .then(res => {
            clientAccess.value = res.data
          })
      })
    }

    getClientAccess()

    const createClientAccess = () => {
      openDialog({
        name: 'ClientAccess',
        action: 'create',
        dialogData: {
          document: documentSignature,
          access: {
            entityId: documentSignatureId.value,
            entityTypeId: ENTITY_TYPE.DOCUMENT_SIGNATURE,
          },
          createHandler: (access: any) => {
            clientAccess.value = [...clientAccess.value, access]
          },
          removeHandler: (access: any) => {
            clientAccess.value = clientAccess.value.filter(
              a => a.id !== access.id
            )
          },
        },
        params: {
          hideActionButtons: true,
        },
      })
    }
    const showClientAccessInfo = (access: any) => {
      openDialog({
        name: 'ClientAccess',
        action: 'preview',
        dialogData: {
          document: documentSignature,
          access,
          removeHandler: (access: any) => {
            clientAccess.value = clientAccess.value.filter(
              a => a.id !== access.id
            )
          },
        },
        params: {
          hideActionButtons: true,
        },
      })
    }
    return { createClientAccess, showClientAccessInfo, clientAccess }
  },
}
</script>

<style scoped lang="scss"></style>
